export const ALL_FIELD: string = "All";
export const STATUS_FIELD: string = "Status";
export const TYPE_FIELD: string = "Type";
export const USER_FIELD: string = "User";
export const FILTER_TITLE_FIELD: string = "FilterTitle";
